/*
**  @desc:    内容位曝光统计
**  @author:  yikuang@sohu-inc.com
**  @date:    2017-06-19
*/

import Helper from '../_utils/helper';
import Exposure from '../_utils/exposure';
import SohuStat from './sohu-stat';

var ContentEvStat = (function() {
    var exposure = new Exposure();
    // 需要曝光的内容元素
    var contentList = [];
    // 已经曝光，等待发统计的曝光位置码
    var waitingList = [];
    // 已经曝光，等待发统计的appid，给客户端用的
    var waitingAppidList = [];
    // 已经曝光，等待发统计的新闻id，格式：文章id_作者id
    var waitingNewsIdList = [];
    // 曝光码属性名
    var logAttr = 'data-log-content-ev';
    // appid属性名
    var appidAttr = 'data-appid';

    function init(contentList, logAttr, appidAttr) {
        contentList = contentList || [];
        logAttr = logAttr || 'data-log-content-ev';
        appidAttr = appidAttr || 'data-appid';
        addContentEv(contentList, logAttr, appidAttr);
        exposure.allExposureCheck();
        exposure.addListener();
        setInterval(function() {
            if(waitingList.length > 0) {
                SohuStat.sendStatistics('content_ev', {
                    location: waitingList.join(','),
                    relatedID: waitingAppidList.join(','),
                    news: waitingNewsIdList.join(',')
                });
                waitingList = [];
                waitingAppidList = [];
                waitingNewsIdList = [];
            }
        }, 1000);
    }

    function allExposureCheck() {
        exposure.allExposureCheck();
    }

    function addContentEv(contentList, logAttr, appidAttr) {
        contentList = contentList || [];
        logAttr = logAttr || 'data-log-content-ev';
        appidAttr = appidAttr || 'data-appid';
        var length = contentList.length;
        for(var i=0; i<length; i++) {
            (function(i) {
                var dom = contentList[i];
                exposure.add({
                    dom: dom,
                    callback: function() {
                        exposeHandler(dom, logAttr, appidAttr);
                    },
                    isHideCheck: (function(dom) {
                        return function() {
                            var topFixed = document.querySelector('.index_head_area') || document.querySelector('.sub-header.fixed');
                            if(topFixed) {
                                return dom.getBoundingClientRect().bottom < topFixed.getBoundingClientRect().height;
                            }else {
                                return false;
                            }
                        }
                    })(dom)
                });
            })(i);
        }
    }

    function exposeHandler(dom, logAttr, appidAttr) {
        var statCode = dom.getAttribute(logAttr);
        if(statCode) {
            waitingList.push(statCode);
        }
    }

    return {
        init: init,
        addContentEv: addContentEv,
        allExposureCheck: allExposureCheck
    };
})();

export default ContentEvStat;


// WEBPACK FOOTER //
// ./src/statistics/content-ev-stat.js